export enum DocumentElement {
  fullscreenElement = 'fullscreenElement',
}
